module.exports = __webpack_public_path__ + "img/52002746_L.c42f9857.png";